module.exports = __webpack_public_path__ + "img/Cook-Islands.9767c0f3.png";